import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-link-proofcard-dialog",
  templateUrl: "./link-proofcard-dialog.component.html",
  styleUrls: ["./link-proofcard-dialog.component.css"],
})
export class LinkProofcardDialogComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  proofcardInfo = {
    email: null,
    proofcardNumber: null,
    proofcardPassword: null,
  };
  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {}

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(this.proofcardInfo);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
